module.exports = __webpack_public_path__ + "static/media/avatar_32.a33b0e7b.svg";